import { Box, makeStyles, Theme } from "@material-ui/core";

type IndicatorProps = {
  color: "warning" | "success" | "error" | "default" | string;
};

type StatusLabelProps = {
  status: string | undefined;
  color?: IndicatorProps["color"];
};

const useStyles = makeStyles<Theme, IndicatorProps>((theme) => ({
  statusContainer: {
    display: "flex",
    alignItems: "center",
    textTransform: "capitalize",
  },
  status: {
    width: 6,
    height: 6,
    marginRight: 8,

    borderRadius: 6,

    backgroundColor: ({ color }) =>
      ["default", "success", "error", "warning"].indexOf(color) !== -1
        ? (color === "default" && theme.palette.blueGrey.main) ||
          // @ts-expect-error
          theme.palette[color].main // errors because string has no overlap
        : color,
  },
}));

export const StatusLabel = ({ color = "default", status = "-" }: StatusLabelProps) => {
  const classes = useStyles({ color });
  return (
    <Box className={classes.statusContainer}>
      <Box className={classes.status} />
      {status}
    </Box>
  );
};
